<template>
    <div class="animated fadeIn pt-1">
        <div v-if="loading" class="loading-container">
            <b-row class="justify-content-center">
                <b-col cols="12" class="text-center">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <div v-else>
            <b-row class="order-header-row">
                <b-col cols="12" md="6" class="mb-2 mb-md-0">
                    <h3 class="order-management-title">Order Management</h3>
                </b-col>
                <b-col cols="12" sm="6" md="3" class="mb-2 mb-md-0">
                    <eb-select
                        type="select"
                        class="select-small-bold w-100"
                        v-model="selectStatusOption"
                        :options="statusOptions"
                        label="text"
                        :id="'selecttime'"
                        :placeholder="'Status'"
                        @input="onStatusChange"
                        :selected="selectStatusOption"
                    ></eb-select>
                </b-col>
                <b-col cols="12" sm="6" md="2" class="mb-2 mb-md-0">
                    <eb-select
                        v-if="hideSelect"
                        type="select"
                        class="select-small-bold w-100"
                        v-model="selectedDurationOption"
                        :options="durationOptions"
                        label="text"
                        :id="'selectduration'"
                        :placeholder="'Time Duration'"
                        :selected="selectedDurationOption.text"
                        @input="changeDuration"
                    ></eb-select>
                    <c-date
                        ref="compRefs"
                        modalRef="modalRef"
                        modalId="dateModal1"
                        @customDateRange="findDateResult"
                    ></c-date>
                </b-col>
                <b-col cols="12" sm="12" md="1" class="mb-2 mb-md-0">
                    <b-button
                        variant="success"
                        class="w-100 w-md-auto reload-btn rounded-0"
                        @click="reloadData"
                        :disabled="loading"
                    >
                        <span
                            v-if="loading"
                            class="fa fa-refresh fa-spin reload-icon-size"
                        />
                        <span v-else class="fa fa-refresh reload-icon-size" />
                    </b-button>
                </b-col>
            </b-row>
            <b-card border-variant="info" class="radius">
                <b-row class="advance-filter-header">
                    <b-col cols="12">
                        <h4>Advance Filter</h4>
                    </b-col>
                </b-row>
                <b-row
                    v-if="showFilter"
                    class="justify-content-end filter-row-compact"
                >
                    <b-col cols="12" md="3" lg="2">
                        <eb-select
                            type="select"
                            class="dropdown"
                            v-model="selectedSellerOption"
                            :options="sellerOptions"
                            label="text"
                            :id="'selectseller'"
                            :placeholder="'Seller'"
                            @input="onSellerChange"
                            :selected="selectedSellerOption"
                        ></eb-select>
                    </b-col>
                    <b-col cols="12" md="4" lg="3">
                        <eb-select
                            type="select"
                            class="dropdown w-100 select-criteria-wide"
                            v-model="selectedSearchOption"
                            :options="searchOptionsData"
                            label="text"
                            :id="'searchby'"
                            placeholder="Select Search Criteria"
                            :selected="selectedSearchOption"
                            @input="onSearchChange"
                        ></eb-select>
                    </b-col>
                    <b-col cols="12" md="3" lg="2" v-if="this.show">
                        <div class="search-input-wrapper">
                            <b-form-input
                                class="searchField"
                                :placeholder="`${
                                    this.show
                                        ? this.selectedSearchOption.text
                                        : 'Enter Order #'
                                }`"
                                v-model="searchQuery"
                                @keyup.enter="getOrderList"
                            ></b-form-input>
                            <eb-button
                                class="searchIcon"
                                classic="btn-light"
                                text=""
                                icon="fa fa-search"
                                iconSide="right"
                                :disabled="searchQuery == ''"
                                @click="getOrderList"
                            ></eb-button>
                        </div>
                    </b-col>
                    <b-col cols="12" md="4" lg="3" v-if="showdropdown">
                        <eb-select
                            type="select"
                            class="dropdown w-100 select-criteria-wide"
                            v-model="selectedOptionSearch"
                            :options="searchOrderOptions"
                            label="text"
                            :id="'searchby'"
                            placeholder="Select Search Criteria"
                            :selected="selectedOptionSearch"
                            @input="onSearchChange"
                        ></eb-select>
                    </b-col>
                    <b-col
                        cols="12"
                        md="3"
                        lg="2"
                        class="ml-auto reset-export-col"
                    >
                        <h4 class="reset" @click="resetFilter">Reset Filter</h4>
                    </b-col>

                    <b-col cols="12" md="3" lg="2" class="export-col">
                        <b-button
                            class="export-btn"
                            size="sm"
                            variant="success"
                            @click="exportData"
                        >
                            <i class="fa fa-download"></i>
                            <span class="ml-1">Export Order</span>
                        </b-button>
                    </b-col>
                </b-row>
                <b-row v-else>
                    <b-col cols="12" md="3">
                        <eb-select
                            type="select"
                            class="dropdown"
                            v-model="selectedSearchOption"
                            :options="searchOptionsData"
                            label="text"
                            :id="'searchby'"
                            placeholder="Select Search Criteria"
                            :selected="selectedSearchOption"
                            @input="onSearchChange"
                        ></eb-select>
                    </b-col>
                    <b-col cols="12" md="3" v-if="this.show">
                        <div class="search-input-wrapper">
                            <b-form-input
                                class="searchField mr-sm-2"
                                :placeholder="`${
                                    this.show
                                        ? this.selectedSearchOption.text
                                        : 'Enter Order #'
                                }`"
                                v-model="searchQuery"
                                @keyup.enter="getOrderList"
                            ></b-form-input>
                            <eb-button
                                class="searchIcon"
                                classic="btn-light"
                                text=""
                                icon="fa fa-search"
                                iconSide="right"
                                :disabled="searchQuery == ''"
                                @click="getOrderList"
                            ></eb-button>
                        </div>
                    </b-col>
                    <b-col cols="12" md="3" v-if="showdropdown">
                        <eb-select
                            type="select"
                            class="dropdown"
                            v-model="selectedOptionSearch"
                            :options="searchOrderOptions"
                            label="text"
                            :id="'searchby'"
                            placeholder="Select Search Criteria"
                            :selected="selectedOptionSearch"
                            @input="onSearchChange"
                        ></eb-select>
                    </b-col>
                    <b-col cols="12" md="3">
                        <h4 class="reset" @click="resetFilter">Reset Filter</h4>
                    </b-col>
                </b-row>
                <hr />
                <div class="order-table-scroll-wrapper">
                    <b-table
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive
                        :items="orderList"
                        :fields="captions"
                        :per-page="perPage"
                        :filter="filter"
                        thead-class="header"
                        show-empty
                        class="mt-3 radius"
                        :no-border-collapse="true"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(empty)">
                            <div v-if="disableSellerKey" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div
                                v-else-if="errorMessage"
                                class="text-center text-danger"
                            >
                                {{ errorMessage }}
                            </div>
                            <div v-else class="text-center">
                                {{ emptyMessage }}
                            </div>
                        </template>
                        <template slot="cell(customerName)" slot-scope="data">
                            <div>{{ data.item.customerName || "N/A" }}</div>
                        </template>
                        <template slot="cell(orderTotal)" slot-scope="data">
                            <div>
                                {{ formatCurrency(data.item.orderTotal) }}
                            </div>
                        </template>
                        <template slot="cell(status)" slot-scope="data">
                            <div>{{ data.item.displayStatus || "N/A" }}</div>
                        </template>
                        <template slot="cell(createdAt)" slot-scope="data">
                            <div>{{ data.item.createdAt | formatedate }}</div>
                        </template>
                        <template slot="cell(action)" slot-scope="data">
                            <b-button
                                size="sm"
                                class="mr-2 button-circle"
                                variant="primary"
                                @click="viewOrderDetails(data.item)"
                            >
                                <i class="fa fa-eye"></i>
                            </b-button>
                        </template>
                    </b-table>
                </div>
                <div
                    v-if="pagination.totalPages > 1 || totalRows > perPage"
                    class="pagination-div"
                >
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="totalRows"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        @change="paginationClick"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import VueSimpleSuggest from "vue-simple-suggest";
import ebButton from "@/components/FormElements/Button";
import ebSelect from "@/components/FormElements/Select.vue";
import moment from "moment";
import currentUserData from "@/mixins/currentUser";
import { AtomSpinner } from "epic-spinners";
import cDate from "@/components/FormElements/CustomDate.vue";
export default {
    mixins: [currentUserData],
    name: "manageOrder",
    components: {
        ebButton,
        ebSelect,
        VueSimpleSuggest,
        cDate,
        AtomSpinner,
    },
    props: {
        showFilter: {
            type: Boolean,
            default: false,
        },
    },
    data: () => {
        return {
            hideSelect: true,
            showdropdown: false,
            show: false,
            searchInput: "",
            startDate: "",
            fromDate: moment().format("YYYY-MM-DD"),
            disableSellerKey: false,
            endDate: "",
            toDate: moment().format("YYYY-MM-DD"),
            timeRange: "",
            allSellerOptions: [],
            sortBy: "createdAt",
            sortDesc: true,
            selectedDurationOption: {
                text: "Today",
                value: 1,
            },
            durationOptions: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 Days",
                    value: 7,
                },
                {
                    text: "30 days",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            searchSellerBy: {
                text: "By Name",
                value: "name",
            },
            searchListOptions: [
                {
                    text: "By Name",
                    value: "name",
                },
                {
                    text: "By Email",
                    value: "email",
                },
                {
                    text: "By Phone",
                    value: "phone",
                },
            ],
            selectedSearchOption: { text: "Search Criteria", value: "" },
            searchOptions: [
                {
                    text: "Order Number",
                    value: "orderId",
                },
                {
                    text: "Seller Name",
                    value: "providerName",
                },
                {
                    text: "Seller Phone No.",
                    value: "providerPhone",
                },
                {
                    text: "Seller Email",
                    value: "providerEmail",
                },
                {
                    text: "Customer Name",
                    value: "customerName",
                },
                {
                    text: "Customer Phone No.",
                    value: "customerPhone",
                },
                {
                    text: "Customer Email",
                    value: "customerEmail",
                },
                {
                    text: "Order Type",
                    value: "type",
                },
            ],
            selectedOptionSearch: { text: "Type of order", value: "" },
            searchOrderOptions: [
                {
                    text: "Product Order",
                    value: "PRODUCT",
                },
                {
                    text: "Service Order",
                    value: "SERVICE",
                },
                {
                    text: "Instore Order",
                    value: "INSTORE",
                },
                {
                    text: "Merchant Order",
                    value: "MERCHANT",
                },
            ],

            selectStatusOption: {
                text: "Order Status (All)",
                value: "",
            },
            statusOptions: [
                {
                    text: "All",
                    value: "",
                },
                {
                    text: "Processing",
                    value: "FULFILLMENT_PENDING",
                },
                {
                    text: "Payment Pending",
                    value: "PAYMENT_PENDING",
                },
                {
                    text: "Out For Delivery",
                    value: "OUT_FOR_DELIVERY",
                },
                {
                    text: "Delivered",
                    value: "DELIVERED",
                },
                {
                    text: "Cancelled",
                    value: "CANCELLED",
                }
            ],
            selectedSellerOption: { text: "All Sellers", value: "all" },
            searchQuery: "",
            showDismissibleAlert: false,
            loading: false,
            errorMessage: "",
            items: [],
            tableFields: [
                {
                    key: "orderId",
                    label: "Order#",
                    sortable: true,
                },
                {
                    key: "createdAt",
                    label: "Order Date",
                    sortable: true,
                },
                {
                    key: "customerName",
                    label: "Customer Name",
                    sortable: false,
                },
                {
                    key: "status",
                    label: "Status",
                    sortable: false,
                },
                {
                    key: "orderTotal",
                    label: "Order Total",
                    sortable: true,
                },
                {
                    key: "action",
                    label: "Action",
                },
            ],
            filter: "",
            caption: "Table",
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            tableData: [],
            perPage: 10,
            totalRows: 0,
            currentPage: 1,
            dark: false,
            pagination: {
                total: 0,
                page: 1,
                limit: 10,
                totalPages: 0,
            },
        };
    },
    computed: {
        sellerOptions() {
            if (this.$currentUserData.category == "SELLER") {
                return [
                    {
                        text: "All Seller",
                        value: "all",
                    },
                    {
                        text: "Direct Sellers",
                        value: "direct",
                    },
                ];
            } else {
                return [
                    {
                        text: "All Seller",
                        value: "all",
                    },
                    {
                        text: "Direct Sellers",
                        value: "direct",
                    },
                    {
                        text: "Include Hierarchy",
                        value: "include",
                    },
                ];
            }
        },
        searchOptionsData() {
            if (this.$currentUserData.category == "SELLER") {
                if (this.selectedSellerOption.value == "direct") {
                    return (this.searchOptions = [
                        {
                            text: "Order Number",
                            value: "orderId",
                        },
                        {
                            text: "Customer Name",
                            value: "customerName",
                        },
                        {
                            text: "Customer Phone No.",
                            value: "customerPhone",
                        },
                        {
                            text: "Customer Email",
                            value: "customerEmail",
                        },
                    ]);
                } else {
                    return (this.searchOptions = [
                        {
                            text: "Order Number",
                            value: "orderId",
                        },
                        {
                            text: "Seller Name",
                            value: "sellerName",
                        },
                        {
                            text: "Seller Phone No.",
                            value: "sellerPhone",
                        },
                        {
                            text: "Seller Email",
                            value: "sellerEmail",
                        },
                        {
                            text: "Customer Name",
                            value: "customerName",
                        },
                        {
                            text: "Customer Phone No.",
                            value: "customerPhone",
                        },
                        {
                            text: "Customer Email",
                            value: "customerEmail",
                        },
                        {
                            text: "Order Type",
                            value: "type",
                        },
                    ]);
                }
            } else {
                return this.searchOptions;
            }
        },
        captions() {
            return [
                this.tableFields[0],
                this.tableFields[1],
                {
                    key: "sellerName",
                    label: "Seller Name",
                    sortable: false,
                },
                ...this.tableFields.slice(2),
            ];
        },
        orderList() {
            const list =
                this.$store.getters["order/GetListOrderAllUsers"] || [];
            return list.map((order) => this.normalizeOrder(order));
        },
        userCategory() {
            return JSON.parse(sessionStorage.getItem("userLogin"))["category"];
        },
        emptyMessage() {
            return this.loading
                ? "Loading..."
                : "No orders found for the selected page.";
        },
    },
    methods: {
        async exportData() {
            this.startDownload();
            let data = [];
            this.disableSellerKey = true;
            let loop = async (page) => {
            let payload = {
                limit: 100,
                page: page,
                status: this.selectStatusOption.value || "",
                userCategory:
                    this.$currentUserData && this.$currentUserData.category,
            };
                await this.$store
                    .dispatch("order/listOrderForAllUsers", payload)
                    .then((res) => {
                        const orders =
                            res && res.data && Array.isArray(res.data.orders)
                                ? res.data.orders
                                : [];
                        const pagination =
                            res && res.data && res.data.pagination
                                ? res.data.pagination
                                : {};
                        this.totalRows = pagination.total || orders.length;
                        orders.map((obj) => {
                            const normalizedOrder = this.normalizeOrder(obj);
                            data.push({
                                OrderId: normalizedOrder.orderId,
                                OrderDate: moment(
                                    String(normalizedOrder.createdAt),
                                ).format("DD/MM/YYYY hh:mm A"),
                                SellerName: normalizedOrder.sellerName,
                                CustomerName: normalizedOrder.customerName,
                                CustomerContact:
                                    normalizedOrder.customerContactName,
                                Status: normalizedOrder.displayStatus,
                                Amount: normalizedOrder.orderTotal,
                            });
                        });
                        this.exportAsCSV(data, "orders");
                        this.finishDownload();
                    })
                    .catch((err) => {
                        this.errorMessage = this.getErrorMessage(err);
                    });
            };
            await loop(1);
            this.disableSellerKey = false;
            this.finishDownload();
            if (data.length !== 0) {
                return data;
            }
        },
        startDownload() {
            this.$toasted.info("Downloading..");
        },
        finishDownload() {
            this.$toasted.clear();
        },
        getErrorMessage(error) {
            const message =
                (error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                (error && error.getMessage) ||
                (error && error.message);
            if (typeof message === "string" && message.trim()) {
                return message;
            }
            return "Unable to fetch orders right now.";
        },
        getValidTenantId() {
            const tenantId = this.$currentUserData && this.$currentUserData._id;
            return typeof tenantId === "string" && tenantId.trim()
                ? tenantId.trim()
                : "";
        },
        getPaginationState(responsePagination = {}) {
            return {
                total: responsePagination.total || 0,
                page: responsePagination.page || this.currentPage || 1,
                limit: responsePagination.limit || this.perPage || 10,
                totalPages: responsePagination.totalPages || 0,
            };
        },
        normalizeOrder(order = {}) {
            const items = Array.isArray(order.items) ? order.items : [];
            const providerOrganizationName =
                order &&
                order.provider &&
                order.provider.organization &&
                order.provider.organization.name;
            const customerName = order && order.customerContact && order.customerContact.name;
            const customerPhone =
                order && order.customer && order.customer.phone;
            const customerEmail =
                order && order.customer && order.customer.email;
            const orderTotal =
                order.orderTotal !== undefined && order.orderTotal !== null
                    ? order.orderTotal
                    : order.orderAmount !== undefined &&
                        order.orderAmount !== null
                      ? order.orderAmount
                      : order.totalAmount !== undefined &&
                          order.totalAmount !== null
                        ? order.totalAmount
                        : 0;
            return {
                ...order,
                _id: order._id || order.id,
                orderId: order.orderId || order._id || "N/A",
                sellerName:
                    order.sellerName ||
                    providerOrganizationName ||
                    items
                        .map((item) => item && item.providerName)
                        .find((name) => !!name) ||
                    "N/A",
                customerName:
                    customerName ||
                    "N/A",

                orderTotal: orderTotal,
                displayStatus: order.status || order.orderStatus || "N/A",
            };
        },
        formatCurrency(amount) {
            const value = Number(amount);
            if (Number.isNaN(value)) {
                return amount || "N/A";
            }
            return value.toLocaleString("en-IN", {
                style: "currency",
                currency: "INR",
                minimumFractionDigits: 2,
            });
        },
        async paginationClick(e) {
            this.currentPage = e;
            await this.getOrderList();
        },
        async onStatusChange(e) {
            this.selectStatusOption = e;
            this.currentPage = 1;
            await this.getOrderList();
        },
        onSearchChange() {
            if (this.selectedSearchOption.value === "type") {
                this.showdropdown = true;
                this.show = false;
            } else {
                this.show = true;
                this.showdropdown = false;
                if (this.searchQuery != "") {
                    this.searchQuery = "";
                }
            }
        },
        viewOrderDetails(data) {
            if (this.$router.history.current.name === "manage-order") {
                this.$router.push({
                    name: "manage-order-details",
                    params: { orderId: data.orderId },
                });
            } else {
                this.$router.push({
                    name: "manage-order-details",
                    params: { orderId: data.orderId },
                });
            }
        },
        async onSellerChange(data) {
            this.selectedSellerOption = data;
            this.currentPage = 1;
            this.disableSellerKey = true;
            await this.getOrderList();
            this.disableSellerKey = false;
        },

        async searchSpecificSeller(sellerData) {
            if (sellerData && sellerData.length >= 3) {
                this.currentPage = 1;
                this.$store.dispatch("order/cleanOrderList");
                let payload = {
                    type: "SELLER",
                    key: this.searchSellerBy.value,
                    keyVal: this.searchInput,
                    includeHierarchy: "y",
                };
                await this.$store.dispatch(
                    "partner/listPartnerSearchByNameEmailPhone",
                    payload,
                );
            }
        },
        async findDateResult(e) {
            this.fromDate = e.fromDate;
            this.toDate = e.toDate;
            this.timeRange = "";
            await this.getOrderList();
        },
        async changeDuration() {
            let e = this.selectedDurationOption;
            if (e.value == "custom") {
                this.hideSelect = false;
                this.$refs["compRefs"].openModal();
                setTimeout(() => {
                    this.hideSelect = true;
                }, 30);
                return;
            } else {
                this.fromDate = moment()
                    .subtract(e.value - 1, "days")
                    .format("YYYY-MM-DD");
                this.toDate = moment().format("YYYY-MM-DD");
                this.startDate = null;
                this.endDate = null;
            }
            await this.getOrderList();
        },
        async getOrderList() {
            this.loading = true;
            this.errorMessage = "";
            this.$store.dispatch("order/cleanOrderList");
            this.disableSellerKey = true;
            let payload = {
                page: this.currentPage,
                limit: this.perPage,
                status: this.selectStatusOption.value || "",
                userCategory:
                    this.$currentUserData && this.$currentUserData.category,
            };
            await this.$store
                .dispatch("order/listOrderForAllUsers", payload)
                .then((res) => {
                    const pagination = this.getPaginationState(
                        res && res.data ? res.data.pagination : {},
                    );
                    this.pagination = pagination;
                    this.totalRows = pagination.total;
                    this.currentPage = pagination.page;
                    this.perPage = pagination.limit;
                })
                .catch((err) => {
                    this.pagination = this.getPaginationState();
                    this.totalRows = 0;
                    this.errorMessage = this.getErrorMessage(err);
                });
            this.disableSellerKey = false;
            this.loading = false;
        },
        async reloadData() {
            this.loading = true;
            await this.getOrderList();
            this.loading = false;
        },
        resetFilter() {
            this.loading = true;
            this.selectedSellerOption = { text: "All Sellers", value: "" };
            this.selectedSearchOption = { text: "Search Criteria", value: "" };
            this.selectedOptionSearch = { text: "Type", value: "type" };
            this.selectStatusOption = {
                text: "Order Status (All)",
                value: "",
            };
            this.searchQuery = "";
            this.currentPage = 1;
            this.getOrderList();
            this.loading = false;
        },
    },
    async mounted() {
        this.loading = true;
        if (this.partnerAllData == null && this.$route.params.id) {
            await this.$store.dispatch(
                "partner/fetchPartnerById",
                this.$route.params.id,
            );
        }
        await this.getOrderList();
        await this.changeDuration();
        this.loading = false;
    },
    created() {
        this.timeRange = 1;
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
            }
        },
    },
};
</script>
<style>
.export-btn {
    float: right;
    width: 111%;
    height: 38px;
}
.dropdown {
    font-size: 12px;
    font-weight: 600;
}
.advance-filter-header {
    margin-bottom: 1rem;
}
.filter-row-compact {
    margin-top: 0.25rem;
}
.filter-row-compact .col,
.filter-row-compact [class*="col-"] {
    padding-left: 6px;
    padding-right: 6px;
}
.filter-row-compact .reset-export-col {
    padding-right: 0;
}
.filter-row-compact .export-col {
    padding-left: 0;
}
.reset {
    color: blue;
    cursor: pointer;
    margin-left: 48px;
    text-decoration: underline;
}
.radius {
    border-radius: 12px;
    overflow: visible !important;
}
.order-table-scroll-wrapper {
    overflow-x: auto;
    overflow-y: visible;
    max-height: none;
}
.radius .form-group .v-select.vs--open {
    z-index: 1050;
    position: relative;
}
.radius .form-group .v-select .vs__dropdown-menu {
    z-index: 1051;
}
.pagination-div {
    float: right;
    padding: 20px 0px;
}
.custom-control-label::after {
    position: absolute;
    top: 0.15625rem;
    left: -1.5rem;
    display: block;
    width: 1.4rem;
    height: 1.4rem;
    content: "";
    background: no-repeat 50%/50% 50%;
}
.custom-control-label::before {
    position: absolute;
    top: 0.15625rem;
    left: -1.5rem;
    display: block;
    width: 1.4rem;
    height: 1.4rem;
    pointer-events: none;
    content: "";
    background-color: #fff;
    border: #000000 solid 2px;
}
.search-input-wrapper {
    position: relative;
}
.search-input-wrapper .searchIcon {
    right: 2px;
}
.searchField {
    font-size: 12px;
    font-weight: 600;
    border-radius: 8px;
    padding: 8px 28px 8px 8px;
    height: 40px;
    width: 100%;
}
.suggestions {
    position: absolute;
    width: 86%;
    z-index: 2;
    border: 1px solid #cbd3d7;
    border-radius: 4px;
    background-color: #ffffff;
    list-style: none;
    padding: 5px 0px;
    margin: 0px;
    margin-top: 1px;
}
.vue-simple-suggest.designed .input-wrapper input {
    padding-left: 16px;
    background-color: #ffffff;
    border: 1px solid #cbd3d7;
    border-radius: 25px !important;
    height: 36px;
}
.suggest-item {
    padding: 4px 15px;
}
.hover {
    cursor: pointer;
    background-color: #5897fb;
    color: #fff;
}
:focus-visible {
    outline: none;
}
@media (max-width: 768px) {
    .searchField {
        width: 100%;
    }
    .search-input-wrapper .searchIcon {
        right: 5px;
        width: auto;
        min-width: 36px;
        height: 36px;
        font-size: 14px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 8px;
    }
    .searchIcon {
        width: 100%;
        text-align: center;
    }
    .reset,
    .export-btn {
        width: 100%;
        text-align: center;
        margin-bottom: 10px;
    }
    .reset {
        margin-left: 0;
    }
    .pagination-div {
        float: none;
        width: 100%;
        text-align: center;
    }
}
.loading-container {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.order-management-title {
    margin-bottom: 0;
}

.select-small-bold {
    font-size: 12px;
    font-weight: 600;
}

.reload-icon-size {
    font-size: 15px;
}

@media (max-width: 991.98px) {
    .order-header-row {
        align-items: center;
    }

    .order-management-title {
        font-size: 1.25rem;
        margin-bottom: 0.5rem;
    }

    .select-small-bold {
        width: 100%;
        margin-bottom: 0.5rem;
    }
}

@media (max-width: 576px) {
    .order-management-title {
        font-size: 1.125rem;
    }
}

@media (max-width: 576px) {
    .search-input-wrapper .searchIcon {
        right: 5px;
        min-width: 32px;
        height: 32px;
        font-size: 12px !important;
        padding: 0 6px;
    }
    .reset,
    .export-btn {
        width: 100%;
        text-align: center;
        margin-bottom: 10px;
    }
    .reset {
        margin-left: 0;
    }
    .pagination-div {
        float: none;
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
    }
}
.reload-btn {
    height: 38px; /* Set your desired height */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 15px;
}
</style>
